import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import Card from "components/card";
import {
    Clock,
    Utensils
} from "lucide-react"
import Button from "components/button";

import { 
	doTimeCardPunch, getUserTimeCardToday
} from "../../../../../redux/timecard/timeCardState";
import ButtonWithConfirm from "components/button/buttonwithconfirm";

export const TIMECARD_IN = 87;
export const TIMECARD_OUT = 88;

const TimeCard = ({user, recordData, userTimeCardToday, saveTimeCardPunch, ...props}) => {

    const [isActive, setIsActive] = useState(false);
    const [workDuration, setWorkDuration] = useState(null);

    const [isLunch, setIsLunch] = useState(false);
    const [lunchSeconds, setLunchSeconds] = useState(0);
    const [currentTime, setCurrentTime] = useState(new Date());

    const [currentDateTime, setCurrentDateTime] = useState(new Date());
    const options = { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' };
    
      useEffect(() => {
        const timer = setInterval(() => {
          setCurrentDateTime(new Date());
          if(recordData?.tmc_punch_in){
            if(recordData.tmc_punch_out){
                setWorkDuration(formatTime(Math.floor((new Date(recordData.tmc_punch_out) - new Date(recordData.tmc_punch_in)) / 1000)));
            }else{
                setWorkDuration(formatTime(Math.floor((new Date() - new Date(recordData.tmc_punch_in)) / 1000)));
            }
          }
          
        }, 1000);
    
        return () => {
          clearInterval(timer);
        };
      }, [recordData]);
    
      useEffect(() => {
          if(user){
            userTimeCardToday({'userId':user.id});
          }
        }, [userTimeCardToday]);
    
      const onClickTimeInHandler = () => {
        recordData?.tmc_punch_in === null && saveTimeCardPunch({'recordId': recordData.tmc_id, 'typeId': TIMECARD_IN, 'typeName': 'IN'});
      };
    
      const onClickTimeOutHandler = () => {
        (recordData?.tmc_punch_in !== null && recordData?.tmc_punch_out === null) && saveTimeCardPunch({'recordId': recordData.tmc_id, 'typeId': TIMECARD_OUT, 'typeName': 'OUT'});
      };

    const formatTime = (sec) => {
        const h = String(Math.floor(sec / 3600)).padStart(2, "0");
        const m = String(Math.floor((sec % 3600) / 60)).padStart(2, "0");
        const s = String(sec % 60).padStart(2, "0");
        return `${h}:${m}:${s}`;
    };

    return (
        <Card className="text-slate-900 flex flex-col gap-6 rounded-xl border border-slate-200 bg-white">
            <div className="pb-6 p-4">
                <div className="flex items-center justify-between mb-3">
                    <div className="p-2 rounded-full bg-blue-50">
                        <Clock className="w-5 h-5 text-blue-600" />
                    </div>
                    {isActive && (
                        <span className="inline-flex items-center justify-center rounded-xl border px-2 py-0.5 font-medium w-fit whitespace-nowrap shrink-0 overflow-hidden border-transparent bg-green-500 text-white text-[10px]">
                            Active
                        </span>
                    )}
                </div>
                <p className="text-[12px] text-slate-700 mb-1">
                    Current Time
                </p>
                <p className="text-[18px] font-bold mb-2">
                    {currentDateTime.toLocaleTimeString()}
                </p>
                {(recordData) && 
                <>
                    {recordData?.tmc_punch_in ? (
                    <>
                        <div className="grid grid-cols-2">
                            <div>
                                <p className="text-[10px] text-slate-700 dark:text-zinc-500 mb-0.5">
                                    Time In
                                </p>
                                <p className="text-[15px] font-semibold text-slate-900 dark:text-zinc-300 mb-2">
                                    {recordData?.tmc_punch_in}
                                </p>
                            </div>
                            <div className="text-right">
                                <p className="text-[10px] text-slate-700 dark:text-zinc-500 mb-0.5">
                                    Work Duration
                                </p>
                                <p className="text-[15px] font-semibold text-green-600 mb-2">
                                    {workDuration}
                                </p>
                            </div>
                        </div>
                        {recordData.tmc_punch_out ? (
                            <div className="grid grid-cols-2">
                                <div>
                                    <p className="text-[10px] text-slate-700 dark:text-zinc-500 mb-0.5">
                                        Time Out
                                    </p>
                                    <p className="text-[15px] font-semibold text-slate-900 dark:text-zinc-300 mb-2">
                                        {recordData?.tmc_punch_out}
                                    </p>
                                </div>
                            </div>
                        ) : <>
                            {isLunch && (
                                <>
                                    <p className="text-[10px] text-slate-700 mb-0.5">
                                        Lunch Break
                                    </p>
                                    <p className="text-[13px] font-semibold text-orange-600 mb-2">
                                    
                                    </p>
                                </>
                            )}
                            <div className="space-y-1.5">
                            {isLunch && (
                                    <Button
                                        onClick={() => setIsLunch(false)}
                                        className="access-button btn-lunch"
                                    >
                                        <Utensils className="w-3 h-3" />
                                        End Lunch Break
                                    </Button>
                            )}
                                {!isLunch && (
                                    <Button 
                                        onClick={() => {
                                            setIsLunch(true);
                                            setLunchSeconds(0);
                                        }}
                                        className="access-button btn-lunch"
                                    >
                                        <Utensils className="w-3 h-3" />
                                        Start Lunch Break
                                </Button>
                                )}
                                <ButtonWithConfirm
                                    className="access-button btn-time-out"
                                    confirmationTitle="Confirm Time OUT"
                                    confirmHandler={onClickTimeOutHandler}
                                >
                                    { recordData?.tmc_punch_out ?? 'Time OUT' }
                                </ButtonWithConfirm>
                            </div>
                        </>
                        }
                        
                    </>
                    ) : <Button
                        onClick={onClickTimeInHandler}
                        className={`access-button btn-time-in text-[11px] w-full`}
                        disabled={recordData?.tmc_punch_in}
                    >
                        { recordData?.tmc_punch_in ?? 'Time IN' }
                    </Button>}
                </>
                }
            </div>
        </Card>
    )
};

const mapStateToProps = (state) => ({
  recordData: state.timeCard.timeCardDetails?.data,
  user: state.auth.user,
});

const mapDispatchToProps = (dispatch) => ({
  saveTimeCardPunch: (data) => dispatch(doTimeCardPunch(data)),
  userTimeCardToday: (data) => dispatch(getUserTimeCardToday(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(TimeCard);